module.exports = __webpack_public_path__ + "static/media/logo-white1.e067ecda.png";